<template>
    <div class="upload-section">
        <div class=" title-wrapper">
            <img src="@/assets/images/onboarding/governmentIcon.svg" alt="gov-icon">
            <h1>Government Documents</h1>
        </div>
        <div>
            <div class="gov-id">
                <h3>Government ID of Signatory <span class="required">*</span></h3>
            </div>
            <div v-if="governmentIdError" class="error-message">This field is
                required</div>
            <div>
                <OnboardingFileUpload :type="upload1" :link="upload1link" :errorType="governmentIdError" />
            </div>

        </div>

        <div class="upload-area-wrapper">
            <div class="gov-id">
                <h3>BIR 2303 <span class="required">*</span></h3>
            </div>
            <div v-if="otherGovenmentDocuError" class="error-message">This field is
                required</div>
            <div>
                <OnboardingFileUpload :type="upload2" :link="upload2link" :errorType="otherGovenmentDocuError" />
            </div>


        </div>
        <div class="upload-area-wrapper last-item">
            <div class="gov-id">
                <h3>Proof of banking <span class="required">*</span></h3>
            </div>
            <div v-if="proofOfBankingError" class="error-message">This field is
                required</div>
            <div>
                <OnboardingFileUpload :type="upload3" :link="upload3link" :errorType="proofOfBankingError" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import OnboardingFileUpload from "@/components/onboarding/OnboardingFileUpload";
export default {
    components: {
        OnboardingFileUpload
    },
    data() {
        return {
            busy: false,
            processing: false,
            counter: 1,
            interval: null,
            upload1: "government_id",
            upload2: "other_government_docu",
            upload3: "banking_proof",
            upload1link: null,
            upload2link: null,
            upload3link: null

        }
    },
    computed: {
        ...mapState("onboarding", {
            bankDetails: state => state.bankDetails,
            bankRequirementsFormErrors: state => state.bankRequirementsFormErrors,
            governmentIdError: state => state.governmentIdError,
            proofOfBankingError: state => state.proofOfBankingError,
            otherGovenmentDocuError: state => state.otherGovenmentDocuError

        }),
    },
    methods: {
        loadDocuments() {
            if (this.bankDetails.documents.length !== 0)
                this.bankDetails.documents.forEach(obj => {
                    if (obj.type === 'government_id') {
                        if (obj.link !== null) {
                            this.upload1link = obj.link
                        }
                    }
                    if (obj.type === 'other_government_docu') {
                        if (obj.link !== null) {
                            this.upload2link = obj.link
                        }
                    }
                    if (obj.type === 'banking_proof') {
                        if (obj.link !== null) {
                            this.upload3link = obj.link
                        }
                    }
                })

        },
    },
    mounted() {



    },

    watch: {
        bankDetails: {
            handler(newValue, oldValue) {
                this.loadDocuments()
            },
            deep: true
        }
    }
}


</script>
<style scoped lang="scss">
.error-border {
    border: solid 2px red;
}

.upload-area-wrapper {
    margin-top: 30px;
}

.last-item {
    margin-bottom: 40px
}

.gov-id {
    margin-bottom: 15px;

    h3 {
        color: #2F3941;
        font-family: MainFontRegular, sans-serif;
        font-size: 13px;
        font-style: normal;
        line-height: normal;
        margin-bottom: 0px;

        .required {
            color: #EA3820;
            margin-left: 3px;
        }

        .not-required {
            color: #87929D;
            text-align: center;
            font-family: MainFontRegular, sans-serif;
            font-size: 14px;
            font-style: normal;
            line-height: normal;
        }
    }

}

.title-wrapper {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E9EBED;
    padding-bottom: 15px;
    margin-bottom: 29px;

    h1 {
        margin-left: 8px;
        color: #2F3941;
        font-family: MainFontRegular, sans-serif;
        font-size: 16px;
        font-style: normal;
        line-height: normal;
        margin-bottom: 0px;
    }
}

.upload-section {
    margin-top: 115px;
    width: 584px;
    border-radius: 10px;
    border: 1px solid #E9EBED;
    background: #FFF;
    box-shadow: 0px 2px 5px -3px rgba(67, 67, 67, 0.25);
    padding: 34px;

    @media (max-width: 1328px) {
        width: 500px;
    }

    @media (max-width: 1102px) {
        width: 650px;
        margin-top: 30px;
    }

    @media (max-width: 672px) {
        max-width: 330px;
    }
}

.error-border {
    border: red 2px solid;
}

.error-message {
    color: red;
    font-size: 12px;
    margin-bottom: 5px;
}
</style>